import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
  viewChild,
} from '@angular/core';
import { MatDrawerContainer } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatMiniFabButton } from '@angular/material/button';
import { filter, map, throttleTime } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DirectRecaptchaV3Service, RecaptchaConfigService } from '@core/services';

@Component({
  selector: 'sky-layout',
  imports: [MatDrawerContainer, RouterOutlet, MatIcon, MatMiniFabButton],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly directRecaptchaV3Service = inject(DirectRecaptchaV3Service);
  private readonly recaptchaConfigService = inject(RecaptchaConfigService);

  private scrollY = 0;

  showScroll = signal<boolean>(false);

  scrollContainer = viewChild<MatDrawerContainer>('scrollContainer');

  ngOnInit(): void {
    this.directRecaptchaV3Service.init(this.recaptchaConfigService.recaptchaSiteKey());
  }

  ngAfterViewInit(): void {
    this.initScrollListener();
  }

  scrollTop(top = 0) {
    this.scrollContainer()?.scrollable?.scrollTo({ top: top, behavior: 'smooth' });
  }

  private initScrollListener() {
    this.scrollContainer()
      ?.scrollable?.elementScrolled()
      .pipe(
        filter(event => event?.type === 'scroll'),
        throttleTime(100),
        map(event => {
          const scrollable = (event?.target as HTMLElement)?.scrollTop >= 1024;

          const scrollY = (event?.target as HTMLElement)?.scrollTop;

          if (scrollY > 0) {
            this.scrollY = scrollY;
          }

          this.showScroll.set(scrollable);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
